export const bodyStyle = {
  "box-sizing": "border-box !important",
  "font-family": "'Arial', sans-serif",
  margin: "0",
  "transition-duration": ".15s"
};
